import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { CategoryGrid } from '../components/CategoryGrid';
import { FeaturedListings } from '../components/FeaturedListings';
import { HowItWorks } from '../components/HowItWorks';
import { AboutLocanto } from '../components/AboutLocanto';
import { Footer } from '../components/Footer';
export function LocantoPage() {
  return <>
      <Helmet data-id="element-244">
        <title data-id="element-245">
          Locanto Singapore — Free Classifieds | Buy, Sell & Find Local Deals
        </title>
        <meta name="description" content="Welcome to Locanto Classifieds Singapore. Post free ads for Jobs, Real Estate, Vehicles, Services, and more. Buy, sell, and connect with your local community. Fast, simple, and 100% free." data-id="element-246" />
        <meta name="keywords" content="Locanto Singapore, free classifieds, buy sell Singapore, jobs Singapore, real estate Singapore, used cars Singapore, local ads, free ads, community marketplace" data-id="element-247" />
        <meta name="robots" content="index, follow" data-id="element-248" />
        <meta name="author" content="Locanto Singapore" data-id="element-249" />
        <link rel="canonical" href="https://www.locanto.sg" data-id="element-250" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-251" />
        <meta property="og:title" content="Locanto Singapore — Free Classifieds | Buy, Sell & Find Local Deals" data-id="element-252" />
        <meta property="og:description" content="Post free classified ads in Singapore. Find Jobs, Real Estate, Vehicles, Services, and more. Join thousands connecting locally every day." data-id="element-253" />
        <meta property="og:url" content="https://www.locanto.sg" data-id="element-254" />
        <meta property="og:site_name" content="Locanto Singapore" data-id="element-255" />
        <meta property="og:locale" content="en_SG" data-id="element-256" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-257" />
        <meta name="twitter:title" content="Locanto Singapore — Free Classifieds" data-id="element-258" />
        <meta name="twitter:description" content="Buy, sell, find jobs, and meet people near you. Post free classified ads in Singapore." data-id="element-259" />

        {/* Additional SEO */}
        <meta name="geo.region" content="SG" data-id="element-260" />
        <meta name="geo.placename" content="Singapore" data-id="element-261" />
        <html lang="en" data-id="element-262" />
      </Helmet>

      <div className="min-h-screen bg-[#F5F5F5] font-sans text-gray-900" data-id="element-263">
        <Header data-id="element-264" />
        <main data-id="element-265">
          <HeroSection data-id="element-266" />
          <CategoryGrid data-id="element-267" />
          <FeaturedListings data-id="element-268" />
          <HowItWorks data-id="element-269" />
          <AboutLocanto data-id="element-270" />
        </main>
        <Footer data-id="element-271" />
      </div>
    </>;
}